import { Company } from "../../../../interface/company";
import { SideMenu } from "../../../../interface/side-menu";
import { roles } from "../../../../shared/lists/roles";

export const TCAR_INTEGRATED_MENU: (company: Company) => SideMenu[] = (company) => {

  const menus: SideMenu[] = [
    // company
    {
      component: 'company',
      href: ['/company'],
      icon: 'domain',
      isTopLevel: true,
    },
    {
      component: 'budgets',
      profileModule: "OS",
      blockedRoles: [roles.mechanic.id],
      icon: 'assignment',
      isTopLevel: true,
      shadows: ['budget-create'],
      children: [
        {
          component: 'budget',
          shadows: ['budget_detail', 'ro_create'],
          profileRule: "OS.list.budget",
          href: ['company', company.id, 'os', 'budget']
        },
        {
          component: 'rejected',
          shadows: ['rejected_detail'],
          profileRule: "OS.list.rejectedBudget",
          href: ['company', company.id, 'os', 'rejected']
        },
      ]
    },
    {
      component: 'ro',
      blockedRoles: [roles.mechanic.id],
      profileModule: "OS",
      icon: 'assignment_turned_in',
      isTopLevel: true,
      shadows: ['ro-create'],
      children: [
        {
          component: 'integrated_opened',
          shadows: ['opened_detail'],
          profileRule: "OS.list.integratedOpen",
          href: ['company', company.id, 'os', 'integrated_opened']
        },
        {
          profileModule: "OS",     // finalizadas
          component: 'finished',
          shadows: ['ended_detail'],
          profileRule: "OS.list.endedRo",
          href: ['company', company.id, 'os', 'ended']
        },

      ]
    },
      {
          component: 'clients',
          profileModule: "CLIENT",
          blockedRoles: [roles.mechanic.id],
          isTopLevel: true,
          icon: 'assignment_ind',
          href: ['company', company.id, 'clients'],
          shadows: ['client-detail']
      },
    {
      component: 'users',
      profileModule: "USER",
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      isTopLevel: true,
      icon: 'people',
      children: [
        {
          profileRule: "USER.REGISTERED_USERS.read",
          component: 'user-list',
          href: ['company', company.id, 'users'],
          shadows: ['user-detail'],
        },
        {
          profileRule: "USER.ACCESS_CONTROL.read",
          component: 'access-profile',
          href: ['company', company.id, 'access-profile'],
          shadows: ['access-profile-edit']
        }
      ]
    },
    {
      component: 'records',
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      isTopLevel: true,
      profileModule: "RECORDS",
      icon: 'note_add',
      children: [
        {
          component: 'checklist',
          profileRule: "RECORDS.mkgChecklist.read",
          href: ['company', company.id, 'records', 'checklist']
        },
        {
          component: 'checklist-models',
          profileRule: "RECORDS.checklistByModel.read",
          href: ['company', company.id, 'records', 'checklist-model']
        },
      ]
    }
  ];
  return menus
}
